import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/net-investment-yield-calculator',
  component: () => import('../../routes/NetInvestmentYield.svelte'),
  card: {
    id: 'net-investment-yield',
    title: 'Net Investment Yield',
    description: 'Calculate your net investment yield after fees and expenses to assess real portfolio performance.',
    icon: 'percent',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/net-investment-yield-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Net Investment Yield Calculator – Calculate Real Portfolio Return After Fees',
    description: 'Calculate the actual net investment yield after accounting for management fees, trading costs, and other expenses. Compare your real return against common benchmarks.',
  },
};

export default meta;
